import React from "react";
import { useLang } from "@/contexts/LanguageContext";

export function LanguageToggle({ dark = false, testId = "language-toggle" }) {
  const { lang, toggle } = useLang();
  const base = dark
    ? "bg-white/15 backdrop-blur-md text-white border border-white/50 hover:bg-white/25 shadow-sm"
    : "bg-white text-slate-900 border border-slate-200 hover:bg-slate-50";
  return (
    <button
      data-testid={testId}
      onClick={toggle}
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${base}`}
      title={lang === "en" ? "Switch to Hindi" : "Switch to English"}
    >
      <span className={lang === "en" ? "font-bold" : "opacity-60"}>A</span>
      <span className="opacity-40">/</span>
      <span className={lang === "hi" ? "font-bold" : "opacity-60"}>अ</span>
    </button>
  );
}
